"use client"

import MenuItem from "../menu-item";
import {motion} from "framer-motion";
import React, {RefObject, useEffect, useRef, useState} from "react";
import {SettingsNavigationProperty} from "@pata/settings";
import {useLocale} from "next-intl";

export type Props = {
    items: Array<SettingsNavigationProperty>,
    additional?: Array<SettingsNavigationProperty>,
    children?: React.ReactNode;
}

const burgerTransitionVariants = {
    open: {
        opacity: 1,
        height: "auto",
        transition: { duration: 0.6 },
        display: "block",
    },
    closed: {
        opacity: 0,
        height: 0,
        transition: { duration: 0.6 },
    },
};

export default function Menu(props: Props) {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [mobileMenuContent, setMobileMenuContent] = useState<Array<SettingsNavigationProperty>>([]);
    const subMenuRef: RefObject<HTMLUListElement | null> = useRef(null)
    const mainMenuRef: RefObject<HTMLUListElement | null> = useRef(null)
    const locale = useLocale();
    
    const toggleMobileMenu = () => {
        setMobileOpen(!mobileOpen);
    }
    
    useEffect(() => {
        function handleResize() {
            if (!subMenuRef.current) return;
            if (!mainMenuRef.current) return;
            let mobileMenuItems: Array<SettingsNavigationProperty> = [];
            
            const listItems = mainMenuRef.current.querySelectorAll("li");
            const hiddenItemCount = Array.from(listItems).filter(
                (item: any) =>
                    item.hidden ||
                    window.getComputedStyle(item).display === "none" ||
                    window.getComputedStyle(item).visibility === "hidden"
            ).length;
            
            if (hiddenItemCount) {
                mobileMenuItems = props.items.slice(-hiddenItemCount, props.items.length)
            }
            
            const screenWidth = document.documentElement.clientWidth;
            if (screenWidth < 768) {
                mobileMenuItems = [...mobileMenuItems, ...(props.additional ?? [])]
            }
            
            setMobileMenuContent(mobileMenuItems);
        }
        handleResize();
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [subMenuRef, mainMenuRef, locale]);
    
    return (
        <div className="menu-container">
            <nav className="main-menu">
                <ul id="menu-galvena-izvelne" className="menu inline-row" ref={mainMenuRef}>
                    {props.items.map((item, i) => (
                        <MenuItem key={i} id={item.htmlId} url={item.path} title={item.name} />
                    ))}
                </ul>
            </nav>
            
            <div className="mobile-menu" style={{display: mobileMenuContent.length ? 'block' : 'none'}}>
                <span className="dots" onClick={toggleMobileMenu} ></span>
            </div>
            
            <motion.ul
                initial="closed"
                animate={mobileOpen ? "open" : "closed"}
                variants={burgerTransitionVariants}
                className="mobile-submenu"
                style={{ overflow: "hidden" }}
                ref={subMenuRef}
            >
                {mobileMenuContent.map((item, i) => (
                    <MenuItem key={i} id={item.htmlId} url={item.path} title={item.name} />
                ))}
            </motion.ul>
        </div>
    )
}